/**
 * Accès aux jetons de design depuis TypeScript.
 *
 * Les valeurs restent dans `tokens.css` : ce module ne fait que rendre les noms
 * de variables, jamais les couleurs elles-mêmes. Recopier `#30d9a0` ici en
 * ferait une seconde source de vérité, qui dériverait.
 */
import type { CSSProperties } from "react";
import type { Bucket } from "../api/types";

/** Nom de la variable CSS qui porte la couleur d'un seau. */
export function bucketColorVar(bucket: Bucket): string {
  return `var(--lde-bucket-${bucket})`;
}

/** Nom de la variable CSS du fond atténué d'un seau (badges, jauges, tuiles). */
export function bucketSoftVar(bucket: Bucket): string {
  return `var(--lde-bucket-${bucket}-soft)`;
}

/**
 * Style à poser sur n'importe quel élément pour le « teindre » d'un seau.
 *
 * Pose deux variables locales, `--seau` et `--seau-doux`, que les feuilles de
 * style des primitives consomment déjà (`Badge`, `Stat`, la jauge). Une
 * primitive n'a donc jamais besoin de quatre règles, une par seau :
 *
 * ```tsx
 * <Stat style={bucketStyle("available")} … />
 * ```
 */
export function bucketStyle(bucket: Bucket): CSSProperties {
  return {
    "--seau": bucketColorVar(bucket),
    "--seau-doux": bucketSoftVar(bucket),
  } as CSSProperties;
}

/** Même mécanisme, pour teindre un élément de la couleur d'accent. */
export function accentStyle(): CSSProperties {
  return {
    "--seau": "var(--lde-accent)",
    "--seau-doux": "var(--lde-accent-soft)",
  } as CSSProperties;
}
